import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

export async function fetchLostFoundItems({ archived = false } = {}) {
  const response = await axios.get(`${config.dev}/v2/lost-found/retrieve`, {
    headers: authHeaders(),
    params: archived ? { archived: true } : undefined,
  });
  return response.data;
}

export async function createLostFoundItem({ title, description, foundDate, status, image }) {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      title,
      description,
      foundDate,
      status,
    })
  );
  if (image) {
    formData.append("file", image);
  }

  const response = await axios.post(`${config.dev}/v2/lost-found/create`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function updateLostFoundItem(id, { title, description, foundDate, status, image }) {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      title,
      description,
      foundDate,
      status,
    })
  );
  if (image) {
    formData.append("file", image);
  }

  const response = await axios.put(`${config.dev}/v2/lost-found/update/${id}`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function updateLostFoundItemStatus(id, status) {
  const response = await axios.put(
    `${config.dev}/v2/lost-found/update/${id}`,
    { status },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function archiveLostFoundItem(id) {
  const response = await axios.put(
    `${config.dev}/v2/lost-found/archive/${id}`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function restoreLostFoundItem(id) {
  const response = await axios.put(
    `${config.dev}/v2/lost-found/restore/${id}`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function deleteLostFoundItem(id) {
  const response = await axios.delete(`${config.dev}/v2/lost-found/delete/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}
